const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '');

export const getApiUrl = (): string => {
    const configured = process.env.REACT_APP_API_URL?.trim();
    if (configured) {
        return trimTrailingSlash(configured);
    }

    if (typeof window === 'undefined') {
        return 'http://localhost:8000';
    }

    const origin = window.location.origin;
    if (origin.includes('localhost') || origin.includes('127.0.0.1')) {
        return 'http://localhost:8000';
    }

    // For ngrok/preview/prod environments, default to same-origin API.
    return trimTrailingSlash(origin);
};

